import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NetworkService } from '../../core/services/network.service';

@Component({
    selector: 'app-product',
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ProductComponent implements OnInit {
    productInfo;
    currentIndex: number;
    currentItem = {
        name: '',
        url: ''
    };
    api;

    constructor(private networkService: NetworkService,
                private route: ActivatedRoute) {}

    ngOnInit() {
        this.fetchProduct();
    }

    fetchProduct() {
        const productId = this.route.snapshot.paramMap.get('id');

        this.networkService.fetchProductInfo(productId)
            .then(response => {
                this.productInfo = response;
                this.getProductHandler();
            })
            .catch(error => {
                console.error(error.message);
            });
    }

    updateProduct(link) {
        this.networkService.getProduct(link)
            .then(response => {
                window.scrollTo(0, 0);

                this.productInfo = response.data[0];
                if (response.links) {
                    this.productInfo['links'] = response.links;
                }

                this.getProductHandler();
            });
    }

    reloadPage() {
        window.scrollTo(0, 0);
        window.location.reload();
    }

    getProductHandler() {
        if (this.productInfo.videos && this.productInfo.videos.length) {
            this.currentIndex = 0;
            this.currentItem = this.productInfo.videos[this.currentIndex];
        }
    }

    onPlayerReady(api) {
        this.api = api;
        this.api.getDefaultMedia().subscriptions.ended.subscribe(() => {
            this.api.play();
        });
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/product/product.component.ts